export function openModalEvent(string: string): `modal:open:${string}` {
  return `modal:open:${string}`;
}
